export default function Tabs({ activeTab, setActiveTab }) {
  return (
    <div className="usecase-header ad-card-header">
      <div className="usecase-tab-buttons">
        <button
          className={`ad-btn ${
            activeTab === "mapping" ? "ad-btn-blue" : "ad-btn-outline"
          }`}
          onClick={() => setActiveTab("mapping")}
        >
          User Role Mapping
        </button>

        <button
          className={`ad-btn ${
            activeTab === "list" ? "ad-btn-blue" : "ad-btn-outline"
          }`}
          onClick={() => setActiveTab("list")}
        >
          Mapped Role List
        </button>
      </div>
    </div>
  );
}